import { FC } from 'react';
import { ProductTile } from 'organisms/ProductTile/index';
import { ProductTileProps } from 'organisms/ProductTile/types';
import styles from './ProductTile.module.css';

export const HomePageTile: FC<ProductTileProps> = (props) => {
  return (
    <ProductTile
      classes={{
        root: styles.homeRoot,
        cover: styles.homeCover,
      }}
      {...props}
    />
  );
};
